import { environment } from "src/environments/environment";

/**
 * Cat?logo de endpoints del frontend.
 *
 * Las constantes se agrupan por el path que resuelven. Dentro de cada bloque
 * se ordenan por URL para localizar y mantener las rutas con rapidez.
 */
export const UrlConstantes = {

  // Path: controller/ ? Endpoints generales
  actualizaDatosPersona:
    environment.apiUrl + "controller/actualizaDatosPersona.do",
  actualizaCorreoNotificacion:
    environment.apiUrl + "controller/actualizaNotiCorreo.do",
  actualizaPassUsuario:
    environment.apiUrl + "controller/actualizaPassUsuario.do",
  loginAdmin: environment.apiUrl + "controller/admin.do",
  agregaActualizaCliente:
    environment.apiUrl + "controller/agregarEditarCliente.do",
  AGREGAR_SALIDA_ENTRADA: environment.apiUrl + "controller/agregarEntradaSalida.do",
  BorrarServidor: environment.apiUrl + "controller/borrarServidor.do",
  BUSCAGEN_CONFIG: environment.apiUrl + "controller/buscaConfigGen.do",
  BUSCA_CONFIG: environment.apiUrl + "controller/buscaConfiguraciones.do",
  consultaPerfiles: environment.apiUrl + "controller/buscaPerfiles.do",
  consultaPerfilesEmpleado:
    environment.apiUrl + "controller/buscaPerfilesXUser.do",
  consultarServidorPorCOSIPPag:
    environment.apiUrl + "controller/buscarServidorCOSIPPag.do",
  consultarServidorPorIP: environment.apiUrl + "controller/buscarServidorIP.do",
  consultarServidorPorIPPag:
    environment.apiUrl + "controller/buscarServidorIPPag.do",
  cancelarProyectoOp: environment.apiUrl + "controller/cancelarProyectoOp.do",
  cerrarSession: environment.apiUrl + "controller/cerrar.do",
  consultaAreasEmpresa:
    environment.apiUrl + "controller/consultaAreasXEmpresa.do",
  consultaAreaxUsuario:
    environment.apiUrl + "controller/consultaAreaxUsuario.do",
  consultaClientesCorporativo:
    environment.apiUrl + "controller/consultaClientesCorporativo.do",
  consultaComentarioRechazo:
    environment.apiUrl + "controller/consultaComentarioRechazo.do",
  CONSULTA_CU_POR_PROYECTO:
    environment.apiUrl + "controller/consultaCuPorProyecto.do",
  consultaDetalleQA: environment.apiUrl + "controller/consultaDetallesQA.do",
  consultaIncidenciaQAXId:
    environment.apiUrl + "controller/consultaIncidenciaQAXId.do",
  // Espejo de CosCore UrlConstantes.CONSINCXFILTROQA: el tablero de QA y «Vincular incidencia» de T2.
  CONSINCXFILTROQA:
    environment.apiUrl + "controller/consultaIncidenciasXFiltroQA.do",
  CONSULTA_DISCUSION:
    environment.apiUrl + "controller/consultaDiscucionXFiltro.do",
  consultaEmpleados: environment.apiUrl + "controller/consultaEmpleados.do",
  consultaEmpleadosActivos:
    environment.apiUrl + "controller/consultaEmpleadosActivos.do",
  consultaEmpleadosHistorial:
    environment.apiUrl + "controller/consultaEmpleadosHistorial.do",
  consultaEmpleadosHistorialSolser:
    environment.apiUrl + "controller/consultaEmpleadosHistorialSolser.do",
  consultarEmpleadosxArea:
    environment.apiUrl + "controller/consultaEmpleadosxArea.do",
  consultaEmpleadosPorPuesto:
    environment.apiUrl + "controller/consultaEmpleadosXPuesto.do",
  consultaEstrategia: environment.apiUrl + "controller/consultaEstrategia.do",
  consultaEvidencia: environment.apiUrl + "controller/consultaEvidencia.do",
  consultaFaseDeteccion:
    environment.apiUrl + "controller/consultaFaseDeteccion.do",
  CONSULTA_FLUJOS_ALTERNOS:
    environment.apiUrl + "controller/consultaFlujosAternos.do",
  consultaHistoCambiosPaginacion:
    environment.apiUrl + "controller/consultaHistoCambiosPaginacion.do",
  CONSULTA_HU_PENDIENTES:
    environment.apiUrl + "controller/consultaHUPendientes.do",
  consultaImpactos: environment.apiUrl + "controller/consultaImpactos.do",
  menusUser: environment.apiUrl + "controller/consultaMenusXUserAngular.do",
  consultaCantidadEmpleados:
    environment.apiUrl + "controller/consultaNumEmpleados.do",
  consultaCantidadHistorial:
    environment.apiUrl + "controller/consultaNumHistorial.do",
  consultaCantidadHistorialSolser:
    environment.apiUrl + "controller/consultaNumHistorialSolser.do",
  consultaCantidadSolicitudes:
    environment.apiUrl + "controller/consultaNumSolicitudes.do",
  CONSULTA_NUM_USUARIOS:
    environment.apiUrl + "controller/consultaNumUsuarios.do",
  consultaPeriodicidad:
    environment.apiUrl + "controller/consultaPeriodicidad.do",
  consultaProbabilidad:
    environment.apiUrl + "controller/consultaProbabilidad.do",
  CONSULTA_PRODUCTOS_SALIDA:
    environment.apiUrl + "controller/consultaProductosSalida.do",
  CONSULTA_PROSPECCION_USER_SEGUIMIENTOS:
    environment.apiUrl + "controller/consultaProspeccionUserSeguimiento.do",
  consultaProyectosPorFiltro:
    environment.apiUrl + "controller/consultaProyectosConFiltro.do",
  consultaProyectosConPaginacion:
    environment.apiUrl + "controller/consultaProyectosConPaginacion.do",
  CONSULTA_PROYECTOS:
    environment.apiUrl + "controller/consultaProyectosXFiltro.do",
  consultaProyectoXUsuario:
    environment.apiUrl + "controller/consultaProyectosXFiltro.do",
  CONSULTA_LISTAPROYECTOS_CON_PAG_FILTROS:
    environment.apiUrl + "controller/consultaProyectPagFiltros.do",
  consultaPuestosArea:
    environment.apiUrl + "controller/consultaPuestosXArea.do",
  consultaPuestoPorAreaPaginacion:
    environment.apiUrl + "controller/consultaPuestoxAreaPaginacion.do",
  CONSULTAR_GRUPOS_REPETIVOS:
    environment.apiUrl + "controller/consultar_Grupos_Repetivos",
  consultarArea: environment.apiUrl + "controller/consultarArea.do",
  consultaAreaPaginacion:
    environment.apiUrl + "controller/consultarAreaPaginacion.do",
  consultarAreaUser: environment.apiUrl + "controller/consultarAreaUser.do",
  consultarComentario: environment.apiUrl + "controller/consultarComentario.do",
  CONSULTAR_COMENTARIOS: environment.apiUrl + "controller/consultarComentarios",
  consultarDetalle: environment.apiUrl + "controller/consultarDetalle.do",
  consultarDetalleMejora:
    environment.apiUrl + "controller/consultarDetalleMejora.do",
  CONSULTAR_DETALLE_SEGUIMIENTO_PROYECTO:    environment.apiUrl + "controller/consultarDetalleSeguimientoProyecto.do",
  consultarEmpresaLista:
    environment.apiUrl + "controller/consultarEmpresaLista.do",
  consultarEstatus: environment.apiUrl + "controller/consultarEstatus.do",
  CONSULTAR_FILTROS_SEGUIMIENTO_PROYECTOS:   environment.apiUrl + "controller/consultarFiltrosSeguimientoProyectos.do",
  CONSULTAR_FILTROS_SEGUIMIENTO_SERVICIOS:   environment.apiUrl + "controller/consultarFiltrosSeguimientoServicios.do",
  CONSULTAR_GRUPOS: environment.apiUrl + "controller/consultarGrupos",
  CONSULTAR_GRUPOS_GITLAB_HIBRIDO:
    environment.apiUrl + "controller/consultarGruposGitlabHibrido",
  consultaRiesgoPaginacion:
    environment.apiUrl + "controller/consultaRiesgoPaginacion.do",
  CONSULTAR_OPORTUNIDAD_DESARROLLADOR:
    environment.apiUrl + "controller/consultarOportunidadDesarrollador",
  CONSULTAR_OPORTUNIDAD_MARKETING:
    environment.apiUrl + "controller/consultarOportunidadMarketing",
  CONSULTAR_OPORTUNIDAD_ODP:
    environment.apiUrl + "controller/consultarOportunidadODP",
  CONSULTAR_OPORTUNIDA_REPETIVAS:
    environment.apiUrl + "controller/consultarOportunidadRepetiva",
  consultarPrioridad: environment.apiUrl + "controller/consultarPrioridad.do",
  CONSULTAR_PROYECTOS_MONGO:
    environment.apiUrl + "controller/consultarProyectosMongo.do",
  CONSULTAR_RESUMEN_SEGUIMIENTO_PROYECTOS:   environment.apiUrl + "controller/consultarResumenSeguimientoProyectos.do",
  CONSULTAR_RESUMEN_SEGUIMIENTO_SERVICIOS:   environment.apiUrl + "controller/consultarResumenSeguimientoServicios.do",
  CONSULTA_SEG_XID: environment.apiUrl + "controller/consultarSeguimientoId.do",
  CONSULTA_LISTA_SEG_XETAPA:
    environment.apiUrl + "controller/consultarSeguimientoProyectoXEtapa.do",
  consultarTicketCapacitacion:
    environment.apiUrl + "controller/consultarTicketCapacitacion.do",
  consultarTicketPerfil:
    environment.apiUrl + "controller/consultarTicketPerfil.do",
  CONSULTAR_TIPO_OPORTUNIDADES:
    environment.apiUrl + "controller/consultarTipoOportunidades",
  consultarTipoSolicitud:
    environment.apiUrl + "controller/consultarTipoSolicitud.do",
  consultaSegmentoCliente:
    environment.apiUrl + "controller/consultaSegmentoCliente.do",
  consultaSeveridad: environment.apiUrl + "controller/consultaSeveridad.do",
  consultaSolicitudesAreaOUsuario:
    environment.apiUrl + "controller/consultaSolicitudesAreaOUsuario.do",
  consultaSolicitudesVacaciones:
    environment.apiUrl + "controller/consultaSolicitudesVacaciones.do",
  consultaSprintPaginacion:
    environment.apiUrl + "controller/consultaSprintPaginacion.do",
  CONSULTA_SPRINT_POR_ETAPA:
    environment.apiUrl + "controller/consultaSprintPorEtapa.do",
  consultaTamanioCliente:
    environment.apiUrl + "controller/consultaTamanioCliente.do",
  CONSULTA_TAREA_X_PROYECTO:
    environment.apiUrl + "controller/consultaTareasPorPoryecto.do",
  CONSULTA_TAREA_X_TIPO:
    environment.apiUrl + "controller/consultaTareasXTipo.do",
  consultaTicketsDepurados:
    environment.apiUrl + "controller/consultaTicketsDepurados.do",
  consultaTiposCliente:
    environment.apiUrl + "controller/consultaTipoCliente.do",
  consultaTipoRiesgo: environment.apiUrl + "controller/consultaTipoRiesgo.do",
  CONSULTA_TIPO_SERVICIO:
    environment.apiUrl + "controller/consultaTipoServicio.do",
  CONSULTAUSUARIOINCIDENCIA:
    environment.apiUrl + "controller/consultaUsuarioIncidencias.do",
  searchVersion: environment.apiUrl + "controller/consultaVersion.do",
  reportesTickest: environment.apiUrl + "controller/creacionYDescarga.do",
  GUARDAR_OPORTUNIDAD: environment.apiUrl + "controller/creaOportunidad",
  eliminarCliente: environment.apiUrl + "controller/deleteClient.do",
  DELETE_CONFIG: environment.apiUrl + "controller/DeleteConfig.do",
  descargarEvidenciaTicket:
    environment.apiUrl + "controller/descargaEvidenciaTicket.do",
  // Video de una evidencia de ticket (por id_evidencia).
  consultaVideoEviTickets: environment.apiUrl + "controller/videoTicket.do",
  CONSULTA_LISTA_RIESGOS_EN_EXCEL:
    environment.apiUrl + "controller/descargarExcelRiesgos.do",
  EDITAR_SALIDA_ENTRADA: environment.apiUrl + "controller/editarEntradaSalida.do",
  editar_estatus: environment.apiUrl + "controller/editarEstatusTicket.do",
  editarPrioridad: environment.apiUrl + "controller/editarPrioridad.do",
  editarTicket: environment.apiUrl + "controller/editarTicket.do",
  ELIMINA_NOTIFICACION_USUARIO:
    environment.apiUrl + "controller/eliminaNotificacionUsuario.do",
  ELIMINAR_AVANCE_SEG:
    environment.apiUrl + "controller/eliminarAvanceProyecto.do",
  ELIMINAR_ISSUE_SEG:
    environment.apiUrl + "controller/eliminarIssueProyecto.do",
  ELIMINAR_RIESGO_SEG:
    environment.apiUrl + "controller/eliminarRiesgoProyecto.do",
  eliminarTarjetaDePublicidad:
    environment.apiUrl + "controller/eliminarTarjetaDePublicidad.do",
  ENVIAR_OPORTUNIDAD_SEGUIMIENTO:
    environment.apiUrl + "controller/enviarOportunidadSeguimiento",
  registroHistorial:
    environment.apiUrl + "controller/exportToExcellRegistro.do",
  FILE_SAVE_OPORTUNIDAD: environment.apiUrl + "controller/fileSaveOportunidad",
  BUSCARAPLICACION: environment.apiUrl + "controller/findApp.do",
  FINDAPPLICATIONBYSERVER: environment.apiUrl + "controller/findApplication.do",
  FINDSERVER: environment.apiUrl + "controller/findServer.do",
  FINDSERVERAdmin: environment.apiUrl + "controller/findServerAdmin.do",
  FINDUSERBYAPPLICATION:
    environment.apiUrl + "controller/findUserByApplication.do",
  FINDUSERBYSERVER: environment.apiUrl + "controller/findUserByServer.do",
  BUSCARUSUARIOPORSERVIDOR: environment.apiUrl + "controller/findUserServer.do",
  fotoPersona: environment.apiUrl + "controller/fotoperfilpersona.do",
  GENERAR_ID_PROYECTO: environment.apiUrl + "controller/generarIdProyecto.do",
  consultaAreaPuestoEmpleado:
    environment.apiUrl + "controller/getAreaPuestoXEmpleado.do",
  consultarImagenPublicidad:
    environment.apiUrl + "controller/getConsultaImagen.do",
  getDatosReporte: environment.apiUrl + "controller/getDatosReporte.do",
  consultaEmpleadosXEtapaPuesto:
    environment.apiUrl + "controller/getEmpleadosXPuestoEmpleado.do",
  consultarPublicidad: environment.apiUrl + "controller/getPublicidad.do",
  GetServerAndUserData:
    environment.apiUrl + "controller/getServerAndUserData.do",
  getSession: environment.apiUrl + "controller/getSession.do",
  obtenerTicketPorEstatus:
    environment.apiUrl + "controller/getTicketPorEstatus.do",
  obtenerTicketPorEstatusYUsuario:
    environment.apiUrl + "controller/getTicketPorEstatusYUsuario.do",
  obtenerTicketFiltroPaginacion:
    environment.apiUrl + "controller/getTicketsFiltroPaginacion.do",
  obtenerTicketFiltroPorUsuario:
    environment.apiUrl + "controller/getTicketsFiltroPorUsuario.do",
  GETUSERDATA: environment.apiUrl + "controller/getUserData.do",
  GET_US_SERVER: environment.apiUrl + "controller/getUserServer.do",
  GET_US_SERVER_APP_COS:
    environment.apiUrl + "controller/getUserServerAPPCOS.do",
  GET_US_SERVER_COS: environment.apiUrl + "controller/getUserServerCOS.do",
  GET_USUARIO_PERFIL: environment.apiUrl + "controller/getUsuarioPerfil.do",
  guardaActualizaEmpleado:
    environment.apiUrl + "controller/guardaActualizaEmpleado.do",
  guardaRiesgo: environment.apiUrl + "controller/guardaActualizaRiesgo.do",
  saveUpdateUsuarios: environment.apiUrl + "controller/guardaActualizaUsuCli",
  guardarArea: environment.apiUrl + "controller/guardaArea.do",
  guardaComentarioRechazo:
    environment.apiUrl + "controller/guardaComentarioRechazo.do",
  GUARDAR_COMENTARIO_OPORTUNIDAD:
    environment.apiUrl + "controller/guardadCometarioOportunidad",
  guardaProductoCliente:
    environment.apiUrl + "controller/guardaProductoCliente.do",
  GUARDAR_ARCHIVO_GIT_OPORTUNIDAD:
    environment.apiUrl + "controller/guardarArchivoGitOportunidad",
  GUARDAR_AVANCE_PROYECTO:
    environment.apiUrl + "controller/guardarAvanceProyecto.do",
  GUARDAR_CASO_USO: environment.apiUrl + "controller/guardarCasoDeUso.do",
  guardarComentario: environment.apiUrl + "controller/guardarComentario.do",
  GUARDAR_COMENTARIO_ARCHIVO_OPORTUNIDAD:
    environment.apiUrl + "controller/guardarComentarioArchivoOportunidad",
  GUARDAR_COMENTARIO_AVANCES:
    environment.apiUrl + "controller/guardarComentarioAvances.do",
  GUARDAR_DISCUSION: environment.apiUrl + "controller/guardarDiscucion.do",
  GUARDAR_EPICA: environment.apiUrl + "controller/guardarEpica.do",
  guardarEvidencia: environment.apiUrl + "controller/guardarEvidencia.do",
  GUARDARGRUPOYEARS: environment.apiUrl + "controller/guardarGrupoYears",
  GUARDAR_HISTORIAL_CAMBIO:
    environment.apiUrl + "controller/guardarHistorialCambio.do",
  GUARDAR_HU: environment.apiUrl + "controller/guardarHu.do",
  GUARDAR_SEGUIMIENTO_SERVICIO:
    environment.apiUrl + "controller/guardarSeguimientoServicio.do",
  guardarImagen: environment.apiUrl + "controller/guardarImagen.do",
  guardaImagenPublicidad:
    environment.apiUrl + "controller/guardarImagenPublicidad.do",
  guardaIncidenciaCliente:
    environment.apiUrl + "controller/guardarIncidenciaCliente.do",
  guardaIncidencia: environment.apiUrl + "controller/guardarIncidenciaQA.do",
  GUARDAR_ISSUE_SEG: environment.apiUrl + "controller/guardarIssueProyecto.do",
  GUARDAR_NUEVOS_ALCANCES:
    environment.apiUrl + "controller/guardarNuevoAlcance.do",
  GUARDAR_OPORTUNIDAD_SEGUIMIENTO:
    environment.apiUrl + "controller/guardarOportunidadSeguimiento",
  GUARDAR_PROSPECTO: environment.apiUrl + "controller/guardarProspecto.do",
  guardarProyecto: environment.apiUrl + "controller/guardarProyecto.do",
  GUARDAR_RIESGO_SEG:
    environment.apiUrl + "controller/guardarRiesgosProyecto.do",
  GUARDAR_SEGUIMIENTO_PROSPECTO:
    environment.apiUrl + "controller/guardarSeguimientoProspecto.do",

  GUARDAR_SEGUIMIENTO_RIESGO:
    environment.apiUrl + "controller/guardarSeguimientoRiesgo.do",
  guardaSolicitud: environment.apiUrl + "controller/guardarSolicitud.do",
  GUARDAR_TAREAS: environment.apiUrl + "controller/guardarTarea.do",
  guardarTicket: environment.apiUrl + "controller/guardarTicket.do",
  guardarTicketCapacitacion:
    environment.apiUrl + "controller/guardarTicketCapacitacion.do",
  guardarTicketMejora: environment.apiUrl + "controller/guardarTicketMejora.do",
  guardarTicketPerfil: environment.apiUrl + "controller/guardarTicketPerfil.do",
  GUARDA_SPRINT_BACKLOG:
    environment.apiUrl + "controller/guardaSprintBacklog.do",
  guardaTarjetaDePublicidad:
    environment.apiUrl + "controller/guardaTarjetaDePublicidad.do",
  LISTA_GRUPOS: environment.apiUrl + "controller/listaGrupos",
  MARCAR_VISTO_NOTIFICACION: "controller/marcarVistoNotificacion.do",
  MARCAR_VISTO_TODAS: "controller/marcarVistoTodas.do",
  mostrarEvidenciaSeguimiento:
    environment.apiUrl + "controller/mostrarEvidenciaSeguimiento",
  consultaImagenEvidencia: environment.apiUrl + "controller/muestraImagen.do",
  OBTENER_NOTIFICACIONES_PG: "controller/obtenerNotificacionPg.do",
  OBTENER_NOTIFICACION_USUARIO:
    environment.apiUrl + "controller/obtenerNotificacionUsuario.do",
  obtenerProductosCliente:
    environment.apiUrl + "controller/obtenerProductosCliente.do",
  OBTENER_RESUMEN_TICKETS: "controller/obtenerResumenTickets.do",
  OBTENER_RESUMEN_TICKETS_SOLICITANTE:
    "controller/obtenerResumenTicketsAreaSolicitante.do",
  obtenerServicios: environment.apiUrl + "controller/obtenerServicios.do",
  OPERACION_TAREA_DIARIA:
    environment.apiUrl + "controller/operacionTareaDiaria.do",
  PROYECTOS_Consulta_Azure: environment.apiUrl + "controller/proyectos.do",
  PROYECTOS_AZURE_TAREAS:
    environment.apiUrl + "controller/tareasProyectoAzure.do",
  RECHAZAR_OPORTUNIDAD_SEGUIMIENTO_REVISION:
    environment.apiUrl + "controller/rechazarOportunidadSeguimientoRevision",
  REGISTRAR_ACTUALIZAR_TAREA_COLABORADOR:
    environment.apiUrl + "controller/registrarTareaXColaborador.do",
  CONSULTAR_PDF_SOLICITUD_VACACIONES:
    environment.apiUrl + "controller/reportePDFSolicitudVacaciones.do",
  DESCARGAR_RPT_EXCEL_TICKETS: "controller/rptEstatusTickets.do",
  SAVECONFIGURATIONUSERBYSERVER:
    environment.apiUrl + "controller/saveConfigurationByServer.do",
  SAVEUPDATE_CONFIG: environment.apiUrl + "controller/saveOrUpdateConfig.do",
  SAVE_SPRINT: environment.apiUrl + "controller/saveSprint.do",
  SEARCHSERVERBYFILTERS: environment.apiUrl + "controller/searchByFilters.do",
  ServerSaveOrUpdate: environment.apiUrl + "controller/serverSaveOrUpdate.do",
  ServidorGestionConsulta:
    environment.apiUrl + "controller/servidorGestionConsulta.do",
  guardaActualizaTokenGit: environment.apiUrl + "controller/setTokenGit.do",
  consultaTicketsPaginacion:
    environment.apiUrl + "controller/ticketsPorEstatusPaginacion.do",
  actualizaStatusEmpleado: environment.apiUrl + "controller/updateStatus.do",
  uploadFotoPersona: environment.apiUrl + "controller/uploadFotoPersona.do",
  uploadEvidencia:
    environment.apiUrl +
    "controller/UploadSeconsultaProyectosXFiltrorviceFX.do",

  // Path: controller/aplicacion/ ? Aplicaciones y servidores
  CONSULTA_NUM_APLICACIONES:
    environment.apiUrl + "controller/aplicacion/consultaNumAplicaciones.do",
  CONSULTA_NUM_APLICACIONES_COS:
    environment.apiUrl + "controller/aplicacion/consultaNumAplicacionesCOS.do",
  CONSULTA_NUM_SERVIDORES:
    environment.apiUrl + "controller/aplicacion/consultaNumServidores.do",
  CONSULTA_NUM_SERVIDORESCOS:
    environment.apiUrl + "controller/aplicacion/consultaNumServidoresCOS.do",
  COUNT_USER_BY_APP:
    environment.apiUrl + "controller/aplicacion/countUserByApp.do",
  COUNT_USER_BY_APPCOS:
    environment.apiUrl + "controller/aplicacion/countUserByAPPCOS.do",
  COUNT_USER_BY_SER:
    environment.apiUrl + "controller/aplicacion/countUserBySER.do",
  COUNT_USER_BY_SER_COS:
    environment.apiUrl + "controller/aplicacion/countUserBySERCOS.do",
  COUNT_USER_DUPLICATE_BY_APP:
    environment.apiUrl +
    "controller/aplicacion/countUserDuplicateByApp.do",
  DELETE_APP: environment.apiUrl + "controller/aplicacion/deleteApp.do",
  DELETE_USER: environment.apiUrl + "controller/aplicacion/deleteUser.do",
  GET_APP_BY_SERVER:
    environment.apiUrl + "controller/aplicacion/finAppByServer.do",
  GET_APP_BY_TYPE:
    environment.apiUrl + "controller/aplicacion/findAppByType.do",
  GET_APP_BY_TYPE_COS:
    environment.apiUrl + "controller/aplicacion/findAppByTypeCOS.do",
  GET_USER_BY_APP:
    environment.apiUrl + "controller/aplicacion/findUserByApp.do",
  GET_USER_BY_APP_PAG:
    environment.apiUrl + "controller/aplicacion/findUserByAppPag.do",
  GET_USER_BY_APP_PAG_COS:
    environment.apiUrl + "controller/aplicacion/findUserByAppPagCOS.do",
  GET_USER_BY_SER:
    environment.apiUrl + "controller/aplicacion/findUserBySER.do",
  GET_USER_BY_SER_PAG:
    environment.apiUrl + "controller/aplicacion/findUserBySERPag.do",
  GET_USER_BY_SER_PAG_COS:
    environment.apiUrl + "controller/aplicacion/findUserBySERPagCOS.do",
  GET_SERVER: environment.apiUrl + "controller/aplicacion/getServer.do",
  GET_SERVER_BY_IP:
    environment.apiUrl + "controller/aplicacion/getServerByIp.do",
  SAVE_OR_UPDATE_USER:
    environment.apiUrl + "controller/aplicacion/saveOrUpdateUser.do",
  SAVE_OR_UPDATE_APP:
    environment.apiUrl + "controller/aplicacion/SaveUpdateApp.do",

  // Path: controller/config/ ? Configuraci?n de servidor
  DELETE_CONFIG_US_APP:
    environment.apiUrl + "controller/config/deleteUserApp.do",
  DELETE_CONFIG_US_SERVER:
    environment.apiUrl + "controller/config/deleteUserServer.do",
  DELETE_CONFIG_US_SERVER_APP:
    environment.apiUrl + "controller/config/deleteUserServerApp.do",
  GET_CONFIG_US_APP: environment.apiUrl + "controller/config/getUsApp.do",
  GET_CONFIG_US_SER: environment.apiUrl + "controller/config/getUsSER.do",
  GET_CONFIG_US_SER_COS:
    environment.apiUrl + "controller/config/getUsSERCOS.do",
  GET_CONFIG_US_SERVER: environment.apiUrl + "controller/config/getUsServer.do",
  BUSCARUSUARIOXAPLICACION:
    environment.apiUrl + "controller/config/searchUserByApplication.do",

  // Path: controller/configuration/ ? Configuraci?n de servidor
  SAVECONFIGURATIONUSERBYAPPLICATION:
    environment.apiUrl +
    "controller/configuration/saveConfigurationByApplication.do",

  // Path: controller/cos/ ? Consultas COS
  findAllCustomers: environment.apiUrl + "controller/cos/consultaClientes.do",
  obtenerProspecto: environment.apiUrl + "controller/cos/consultaProspecto.do",
  CONSULTA_SEGUIMIENTOS_RIESGOS:
    environment.apiUrl + "controller/cos/consultaSeguimientosRiesgo.do",
  CONSULTA_PROSPECTOS:
    environment.apiUrl + "controller/cos/filtrarProspectos.do",
  filtroClientes:
    environment.apiUrl + "controller/cos/filtroConsultaClientes.do",
  filtroClientesGestion:
    environment.apiUrl + "controller/cos/filtroConsultaClientesGestion.do",

  // Path: controller/cos/gestion/ ? Gesti?n COS
  actualizaEstatusUsCliente:
    environment.apiUrl + "controller/cos/gestion/EstatusUsuarioCliente.do",
  filtroUsuariosClientes:
    environment.apiUrl + "controller/cos/gestion/FitroUsuarioCliente.do",

  // Path: controller/denuncias/ ? Canal de denuncias (administraci?n)
  DENUNCIA_ACTUALIZAR_ESTATUS: "controller/denuncias/actualizarEstatus.do",
  DENUNCIA_ASIGNAR_USUARIO: "controller/denuncias/asignarUsuario.do",
  DENUNCIA_CONSULTAR_DETALLE: "controller/denuncias/consultarDetalle.do",
  DENUNCIA_HISTORIAL: "controller/denuncias/consultarHistorial.do",
  DENUNCIA_CONSULTAR_KANBAN: "controller/denuncias/consultarKanban.do",
  DENUNCIA_CONSULTAR_TABLA: "controller/denuncias/consultarTabla.do",
  DENUNCIA_CORREOS_COPIA: "controller/denuncias/correosCopia.do",
  DENUNCIA_DASHBOARD: "controller/denuncias/dashboard.do",
  DENUNCIA_ELIMINAR_CORREO_COPIA: "controller/denuncias/eliminarCorreoCopia.do",
  DENUNCIA_EVIDENCIA_IMG: "controller/denuncias/evidencia.do",
  DENUNCIA_GUARDAR_COMENTARIO: "controller/denuncias/guardarComentario.do",
  DENUNCIA_GUARDAR_CORREO_COPIA: "controller/denuncias/guardarCorreoCopia.do",

  // Path: controller/host/incidencias/ ? Incidencias de host
  ISO42001_INCIDENCIA_HOST_ACTUALIZAR: environment.apiUrl + "controller/host/incidencias/actualizar.do",
  ISO42001_INCIDENCIA_HOST_ARCHIVO_DESCARGAR: environment.apiUrl + "controller/host/incidencias/archivo/descargar.do",
  ISO42001_INCIDENCIA_HOST_ARCHIVO_UPLOAD: environment.apiUrl + "controller/host/incidencias/archivo/upload.do",
  ISO42001_INCIDENCIA_HOST_CAMBIAR_ESTADO: environment.apiUrl + "controller/host/incidencias/cambiarEstado.do",
  ISO42001_INCIDENCIA_HOST_CATALOGOS: environment.apiUrl + "controller/host/incidencias/catalogos.do",
  ISO42001_INCIDENCIA_HOST_COMENTARIO_ACTUALIZAR: environment.apiUrl + "controller/host/incidencias/comentario/actualizar.do",
  ISO42001_INCIDENCIA_HOST_COMENTARIO_GUARDAR: environment.apiUrl + "controller/host/incidencias/comentario/guardar.do",
  ISO42001_INCIDENCIA_HOST_CONSULTAR_KANBAN: environment.apiUrl + "controller/host/incidencias/consultarKanban.do",
  ISO42001_INCIDENCIA_HOST_DETALLE_GUARDAR: environment.apiUrl + "controller/host/incidencias/detalle/guardar.do",
  ISO42001_INCIDENCIA_HOST_GUARDAR: environment.apiUrl + "controller/host/incidencias/guardar.do",
  ISO42001_INCIDENCIA_HOST_OBTENER: environment.apiUrl + "controller/host/incidencias/obtener.do",
  ISO42001_INCIDENCIA_HOST_TIPO_SERVICIO_GUARDAR: environment.apiUrl + "controller/host/incidencias/tipoServicio/guardar.do",

  // Path: controller/incidenciasCliente/ ? Incidencias de cliente
  consultaBandejaIncidenciasCliente:
    environment.apiUrl + "controller/incidenciasCliente/bandeja.do",
  consultaProyectosClienteIncidencias:
    environment.apiUrl + "controller/incidenciasCliente/consultaProyectosCliente.do",
  consultaIncidenciasClienteDashboard:
    environment.apiUrl + "controller/incidenciasCliente/dashboard.do",
  importarIncidenciaClienteQA:
    environment.apiUrl + "controller/incidenciasCliente/importarQA.do",

  // Path: controller/iso42001/inventario/ ? ISO/IEC 42001 ? inventario de activos de IA
  ISO42001_INVENTARIO_ACTUALIZAR: environment.apiUrl + "controller/iso42001/inventario/actualizar.do",
  ISO42001_INVENTARIO_ESTATUS:    environment.apiUrl + "controller/iso42001/inventario/cambiarEstatus.do",
  ISO42001_INVENTARIO_CONSULTAR:  environment.apiUrl + "controller/iso42001/inventario/consultar.do",
  ISO42001_INVENTARIO_ELIMINAR:   environment.apiUrl + "controller/iso42001/inventario/eliminar.do",
  ISO42001_INVENTARIO_GUARDAR:    environment.apiUrl + "controller/iso42001/inventario/guardar.do",
  ISO42001_INVENTARIO_HISTORIAL:  environment.apiUrl + "controller/iso42001/inventario/historial.do",
  ISO42001_INVENTARIO_OBTENER:    environment.apiUrl + "controller/iso42001/inventario/obtener.do",

  // Path: controller/iso42001/matriz/ - ISO/IEC 42001 - matriz de riesgos FOS-005 IA-001
  ISO42001_MATRIZ_CONSULTAR:      environment.apiUrl + "controller/iso42001/matriz/consultar.do",
  ISO42001_MATRIZ_CONSULTAR_COMPLETO: environment.apiUrl + "controller/iso42001/matriz/consultarCompleto.do",
  ISO42001_MATRIZ_OBTENER:        environment.apiUrl + "controller/iso42001/matriz/obtener.do",
  ISO42001_MATRIZ_GUARDAR:        environment.apiUrl + "controller/iso42001/matriz/guardar.do",
  ISO42001_MATRIZ_ACTUALIZAR:     environment.apiUrl + "controller/iso42001/matriz/actualizar.do",
  ISO42001_MATRIZ_ESTATUS:        environment.apiUrl + "controller/iso42001/matriz/cambiarEstatus.do",
  ISO42001_MATRIZ_ELIMINAR:       environment.apiUrl + "controller/iso42001/matriz/eliminar.do",
  ISO42001_MATRIZ_HISTORIAL:      environment.apiUrl + "controller/iso42001/matriz/historial.do",

  // Copias de seguridad de la matriz: versiones anteriores de un activo o de
  // un riesgo, papelera de lo eliminado y vuelta atras.
  ISO42001_RESP_CONSULTAR:        environment.apiUrl + "controller/iso42001/respaldo/consultar.do",
  ISO42001_RESP_ELIMINADOS:       environment.apiUrl + "controller/iso42001/respaldo/eliminados.do",
  ISO42001_RESP_RESTAURAR:        environment.apiUrl + "controller/iso42001/respaldo/restaurar.do",
  ISO42001_RESP_COMPARAR:         environment.apiUrl + "controller/iso42001/respaldo/comparar.do",
  ISO42001_MATRIZ_SEG_GUARDAR:    environment.apiUrl + "controller/iso42001/matriz/seguimiento/guardar.do",
  ISO42001_MATRIZ_SEG_ELIMINAR:   environment.apiUrl + "controller/iso42001/matriz/seguimiento/eliminar.do",
  ISO42001_MATRIZ_SEG_ACTUALIZAR: environment.apiUrl + "controller/iso42001/matriz/seguimiento/actualizar.do",
  ISO42001_MATRIZ_CATALOGOS:      environment.apiUrl + "controller/iso42001/matriz/catalogos.do",
  ISO42001_MATRIZ_EXPORTAR:       environment.apiUrl + "controller/iso42001/matriz/exportar.do",

  // Gestión de Riesgos: las matrices por área. Crear una da de alta también
  // su renglón en el menú lateral.
  ISO42001_GR_CONSULTAR:  environment.apiUrl + "controller/iso42001/gestionRiesgos/consultar.do",
  ISO42001_GR_OBTENER:    environment.apiUrl + "controller/iso42001/gestionRiesgos/obtener.do",
  ISO42001_GR_CREAR:      environment.apiUrl + "controller/iso42001/gestionRiesgos/crear.do",
  ISO42001_GR_ACTUALIZAR: environment.apiUrl + "controller/iso42001/gestionRiesgos/actualizar.do",
  ISO42001_GR_ESTATUS:    environment.apiUrl + "controller/iso42001/gestionRiesgos/cambiarEstatus.do",
  ISO42001_GR_ELIMINAR:   environment.apiUrl + "controller/iso42001/gestionRiesgos/eliminar.do",
  // Borrado con contenido: pide perfil autorizado y contraseña del usuario.
  ISO42001_GR_ELIMINAR_TODO: environment.apiUrl + "controller/iso42001/gestionRiesgos/eliminarCompleta.do",
  // Resumen de la pestana Riesgos del Dashboard de Inicio ({fechaIni, fechaFin}); devuelve un bean con SelloDeError.
  ISO42001_GR_DASHBOARD:  environment.apiUrl + "controller/iso42001/gestionRiesgos/dashboard.do",
  // Avisos de monitoreo (29/09/2026, solo en pantalla): quién los recibe en
  // cada matriz y lo que hace falta para saber qué vence.
  ISO42001_GR_AVISOS:         environment.apiUrl + "controller/iso42001/gestionRiesgos/avisos.do",
  ISO42001_GR_AVISOS_GUARDAR: environment.apiUrl + "controller/iso42001/gestionRiesgos/avisos/guardar.do",
  ISO42001_GR_MONITOREOS:     environment.apiUrl + "controller/iso42001/gestionRiesgos/monitoreos.do",
  // Carga del FOS-005: la previa no escribe nada; crear.do es el que da de alta.
  ISO42001_GR_PREVIA:    environment.apiUrl + "controller/iso42001/gestionRiesgos/importar/previa.do",
  ISO42001_GR_IMPORTAR:  environment.apiUrl + "controller/iso42001/gestionRiesgos/importar/crear.do",

  // Evidencias adjuntas de la matriz (activos y riesgos de proceso).
  // subir.do es multipart (file + tipoOrigen + idOrigen); descargar.do
  // regresa los bytes con su mime real, para verse inline en el navegador.
  ISO42001_MATRIZ_EVIDENCIA_SUBIR:     environment.apiUrl + "controller/iso42001/matriz/evidencia/subir.do",
  ISO42001_MATRIZ_EVIDENCIA_CONSULTAR: environment.apiUrl + "controller/iso42001/matriz/evidencia/consultar.do",
  ISO42001_MATRIZ_EVIDENCIA_DESCARGAR: environment.apiUrl + "controller/iso42001/matriz/evidencia/descargar.do",
  ISO42001_MATRIZ_EVIDENCIA_ELIMINAR:  environment.apiUrl + "controller/iso42001/matriz/evidencia/eliminar.do",
  ISO42001_MATRIZ_EVIDENCIA_APLICA:    environment.apiUrl + "controller/iso42001/matriz/evidencia/aplica.do",

  // Path: controller/iso42001/hojasApoyo/ - configuracion de las hojas de
  // apoyo del FOS-005. Escriben en las MISMAS tablas que lee la matriz.
  ISO42001_HOJAS_CONSULTAR:       environment.apiUrl + "controller/iso42001/hojasApoyo/consultar.do",
  ISO42001_HOJAS_GUARDAR:         environment.apiUrl + "controller/iso42001/hojasApoyo/guardar.do",
  ISO42001_HOJAS_ELIMINAR:        environment.apiUrl + "controller/iso42001/hojasApoyo/eliminar.do",

  // Path: controller/iso42001/riesgoProceso/ - hoja "Plan Gestion RSK"
  ISO42001_RIESGOPROC_CONSULTAR:  environment.apiUrl + "controller/iso42001/riesgoProceso/consultar.do",
  ISO42001_RIESGOPROC_CONSULTAR_COMPLETO: environment.apiUrl + "controller/iso42001/riesgoProceso/consultarCompleto.do",
  ISO42001_RIESGOPROC_OBTENER:    environment.apiUrl + "controller/iso42001/riesgoProceso/obtener.do",
  ISO42001_RIESGOPROC_GUARDAR:    environment.apiUrl + "controller/iso42001/riesgoProceso/guardar.do",
  ISO42001_RIESGOPROC_ACTUALIZAR: environment.apiUrl + "controller/iso42001/riesgoProceso/actualizar.do",
  ISO42001_RIESGOPROC_ELIMINAR:   environment.apiUrl + "controller/iso42001/riesgoProceso/eliminar.do",
  ISO42001_RIESGOPROC_SEG_GUARDAR: environment.apiUrl + "controller/iso42001/riesgoProceso/seguimiento/guardar.do",
  ISO42001_RIESGOPROC_SEG_ELIMINAR: environment.apiUrl + "controller/iso42001/riesgoProceso/seguimiento/eliminar.do",
  ISO42001_RIESGOPROC_SEG_ACTUALIZAR: environment.apiUrl + "controller/iso42001/riesgoProceso/seguimiento/actualizar.do",
  ISO42001_RIESGOPROC_HISTORIAL:  environment.apiUrl + "controller/iso42001/riesgoProceso/historial.do",

  // Path: controller/iso42001/pendiente/ - borrador de cambios: lo capturado espera revision.
  // consultar.do devuelve {pendientes (solo PENDIENTE), resueltos, aprobacionActiva}.
  ISO42001_PEND_CONSULTAR:        environment.apiUrl + "controller/iso42001/pendiente/consultar.do",
  // detalle.do: hoy contra lo propuesto (solo lectura). aceptar.do lo aplica;
  // descartar.do exige motivo. Los tres piden el perfil de edicion.
  ISO42001_PEND_DETALLE:          environment.apiUrl + "controller/iso42001/pendiente/detalle.do",
  ISO42001_PEND_ACEPTAR:          environment.apiUrl + "controller/iso42001/pendiente/aceptar.do",
  ISO42001_PEND_DESCARTAR:        environment.apiUrl + "controller/iso42001/pendiente/descartar.do",

  // Path: controller/iso42001/matriz/version/ - hoja "Hoja de Control de Cambios"
  ISO42001_MATRIZ_VER_CONSULTAR:  environment.apiUrl + "controller/iso42001/matriz/version/consultar.do",
  ISO42001_MATRIZ_VER_GUARDAR:    environment.apiUrl + "controller/iso42001/matriz/version/guardar.do",
  ISO42001_MATRIZ_VER_ACTUALIZAR: environment.apiUrl + "controller/iso42001/matriz/version/actualizar.do",
  ISO42001_MATRIZ_VER_ELIMINAR:   environment.apiUrl + "controller/iso42001/matriz/version/eliminar.do",

  // Path: controller/iso42001/catalogos/ ? ISO/IEC 42001 ? cat?logos
  ISO42001_CAT_CICLO_VIDA:        environment.apiUrl + "controller/iso42001/catalogos/ciclosVida.do",
  ISO42001_CAT_NIVEL_SUPERVISION: environment.apiUrl + "controller/iso42001/catalogos/nivelesSupervision.do",
  ISO42001_CAT_TIPO_IMPACTO:      environment.apiUrl + "controller/iso42001/catalogos/tiposImpacto.do",
  ISO42001_CAT_AREA:              environment.apiUrl + "controller/iso42001/catalogos/areas.do",

  // Path: controller/iso42001/monitoreo/ ? ISO/IEC 42001 ? monitoreo continuo
  ISO42001_MONITOREO_ACTUALIZAR:  environment.apiUrl + "controller/iso42001/monitoreo/actualizar.do",
  ISO42001_MONITOREO_CONSULTAR:   environment.apiUrl + "controller/iso42001/monitoreo/consultar.do",
  ISO42001_MONITOREO_ELIMINAR:    environment.apiUrl + "controller/iso42001/monitoreo/eliminar.do",
  ISO42001_MONITOREO_GUARDAR:     environment.apiUrl + "controller/iso42001/monitoreo/guardar.do",
  ISO42001_MONITOREO_OBTENER:     environment.apiUrl + "controller/iso42001/monitoreo/obtener.do",

  // Path: controller/iso42001/dashboard - pestaña IA del Dashboard de Inicio (gobernanza ISO/IEC 42001)
  ISO42001_DASHBOARD:             environment.apiUrl + "controller/iso42001/dashboard.do",

  // Path: controller/iso42001/admin/ ? ISO/IEC 42001 ? administraci?n de cat?logos
  ISO42001_ADMIN_CICLO_ESTATUS:   environment.apiUrl + "controller/iso42001/admin/cicloVida/cambiarEstatus.do",
  ISO42001_ADMIN_CICLO_GUARDAR:   environment.apiUrl + "controller/iso42001/admin/cicloVida/guardar.do",
  ISO42001_ADMIN_CICLO_LISTAR:    environment.apiUrl + "controller/iso42001/admin/cicloVida/listar.do",
  ISO42001_ADMIN_NIVEL_ESTATUS:   environment.apiUrl + "controller/iso42001/admin/nivelSupervision/cambiarEstatus.do",
  ISO42001_ADMIN_NIVEL_GUARDAR:   environment.apiUrl + "controller/iso42001/admin/nivelSupervision/guardar.do",
  ISO42001_ADMIN_NIVEL_LISTAR:    environment.apiUrl + "controller/iso42001/admin/nivelSupervision/listar.do",
  ISO42001_ADMIN_IMPACTO_ESTATUS: environment.apiUrl + "controller/iso42001/admin/tipoImpacto/cambiarEstatus.do",
  ISO42001_ADMIN_IMPACTO_GUARDAR: environment.apiUrl + "controller/iso42001/admin/tipoImpacto/guardar.do",
  ISO42001_ADMIN_IMPACTO_LISTAR:  environment.apiUrl + "controller/iso42001/admin/tipoImpacto/listar.do",

  // Path: controller/iso42001/incidencias/ ? ISO/IEC 42001 ? incidencias IA
  ISO42001_INCIDENCIA_IA_ACTUALIZAR: environment.apiUrl + "controller/iso42001/incidencias/actualizar.do",
  ISO42001_INCIDENCIA_IA_CAMBIAR_ESTADO: environment.apiUrl + "controller/iso42001/incidencias/cambiarEstado.do",
  ISO42001_INCIDENCIA_IA_CONSULTAR_KANBAN: environment.apiUrl + "controller/iso42001/incidencias/consultarKanban.do",
  ISO42001_INCIDENCIA_IA_GUARDAR: environment.apiUrl + "controller/iso42001/incidencias/guardar.do",
  ISO42001_INCIDENCIA_IA_GUARDAR_COMENTARIO: environment.apiUrl + "controller/iso42001/incidencias/guardarComentario.do",
  ISO42001_INCIDENCIA_IA_OBTENER: environment.apiUrl + "controller/iso42001/incidencias/obtener.do",
  ISO42001_INCIDENCIA_IA_RESPONSABLES: environment.apiUrl + "controller/iso42001/incidencias/responsables.do",

  // Path: controller/seguridad/incidencias/ ? Incidencias de seguridad
  ISO42001_INCIDENCIA_SEGURIDAD_ACTUALIZAR: environment.apiUrl + "controller/seguridad/incidencias/actualizar.do",
  ISO42001_INCIDENCIA_SEGURIDAD_CAMBIAR_ESTADO: environment.apiUrl + "controller/seguridad/incidencias/cambiarEstado.do",
  ISO42001_INCIDENCIA_SEGURIDAD_CONSULTAR_KANBAN: environment.apiUrl + "controller/seguridad/incidencias/consultarKanban.do",
  ISO42001_INCIDENCIA_SEGURIDAD_GUARDAR: environment.apiUrl + "controller/seguridad/incidencias/guardar.do",
  ISO42001_INCIDENCIA_SEGURIDAD_GUARDAR_COMENTARIO: environment.apiUrl + "controller/seguridad/incidencias/guardarComentario.do",
  ISO42001_INCIDENCIA_SEGURIDAD_OBTENER: environment.apiUrl + "controller/seguridad/incidencias/obtener.do",
  ISO42001_INCIDENCIA_SEGURIDAD_RESPONSABLES: environment.apiUrl + "controller/seguridad/incidencias/responsables.do",
  ISO42001_INCIDENCIA_SEGURIDAD_REVISION_CONSULTAR: environment.apiUrl + "controller/seguridad/incidencias/revisionMensual/consultar.do",
  ISO42001_INCIDENCIA_SEGURIDAD_REVISION_GUARDAR: environment.apiUrl + "controller/seguridad/incidencias/revisionMensual/guardar.do",
  ISO42001_INCIDENCIA_SEGURIDAD_REVISION_VENTANA: environment.apiUrl + "controller/seguridad/incidencias/revisionMensual/ventana.do",

  // Path: controller/tarea/horarios/ ? Horarios laborales
  ASIGNAR_HORARIO_EMPLEADO:
    environment.apiUrl + "controller/tarea/horarios/asignarEmpleado.do",
  CONSULTA_HORARIOS_LABORALES:
    environment.apiUrl + "controller/tarea/horarios/consulta.do",
  CONSULTA_ASIGNACIONES_HORARIO_EMPLEADO:
    environment.apiUrl +
    "controller/tarea/horarios/consultaAsignacionEmpleado.do",
  CONSULTA_JORNADA_HORARIO_EMPLEADO:
    environment.apiUrl + "controller/tarea/horarios/consultaJornadaEmpleado.do",
  DETALLE_HORARIO_LABORAL:
    environment.apiUrl + "controller/tarea/horarios/detalle.do",
  GUARDAR_HORARIO_LABORAL:
    environment.apiUrl + "controller/tarea/horarios/guardar.do",

  // Path: controller/asistencia/ ? Asistencia con puntualidad y modalidades
  ASISTENCIA_MI_DIA: environment.apiUrl + "controller/asistencia/miDia.do",
  ASISTENCIA_REGISTRAR:
    environment.apiUrl + "controller/asistencia/registrar.do",
  ASISTENCIA_MI_PLAN: environment.apiUrl + "controller/asistencia/miPlan.do",
  ASISTENCIA_DECLARAR_PLAN:
    environment.apiUrl + "controller/asistencia/declararPlan.do",
  ASISTENCIA_BORRAR_PLAN:
    environment.apiUrl + "controller/asistencia/borrarPlan.do",
  ASISTENCIA_MONITOREO:
    environment.apiUrl + "controller/asistencia/monitoreo.do",
  ASISTENCIA_MONITOREO_RESUMEN:
    environment.apiUrl + "controller/asistencia/monitoreoResumen.do",
  ASISTENCIA_ESTACION_EMITIR:
    environment.apiUrl + "controller/asistencia/estacion/emitir.do",
  ASISTENCIA_ESTACION_CONSULTA:
    environment.apiUrl + "controller/asistencia/estacion/consulta.do",
  ASISTENCIA_ESTACION_REVOCAR:
    environment.apiUrl + "controller/asistencia/estacion/revocar.do",
  ASISTENCIA_UBICACION_CONSULTA:
    environment.apiUrl + "controller/asistencia/ubicacion/consulta.do",
  ASISTENCIA_UBICACION_GUARDAR:
    environment.apiUrl + "controller/asistencia/ubicacion/guardar.do",
  ASISTENCIA_UBICACION_DESACTIVAR:
    environment.apiUrl + "controller/asistencia/ubicacion/desactivar.do",
  ASISTENCIA_UBICACION_REACTIVAR:
    environment.apiUrl + "controller/asistencia/ubicacion/reactivar.do",
  ASISTENCIA_MODALIDAD_CONSULTA:
    environment.apiUrl + "controller/asistencia/modalidad/consulta.do",
  ASISTENCIA_MODALIDAD_ASIGNAR:
    environment.apiUrl + "controller/asistencia/modalidad/asignar.do",
  ASISTENCIA_MODALIDAD_PLANTILLA:
    environment.apiUrl + "controller/asistencia/modalidad/plantilla.do",
  ASISTENCIA_CONFIG_CONSULTA:
    environment.apiUrl + "controller/asistencia/config/consulta.do",
  ASISTENCIA_CONFIG_GUARDAR:
    environment.apiUrl + "controller/asistencia/config/guardar.do",
  ASISTENCIA_DISPOSITIVO_CONSULTA:
    environment.apiUrl + "controller/asistencia/dispositivo/consulta.do",
  ASISTENCIA_DISPOSITIVO_VINCULAR:
    environment.apiUrl + "controller/asistencia/dispositivo/vincular.do",
  ASISTENCIA_DISPOSITIVO_APROBAR:
    environment.apiUrl + "controller/asistencia/dispositivo/aprobar.do",
  ASISTENCIA_DISPOSITIVO_REVOCAR:
    environment.apiUrl + "controller/asistencia/dispositivo/revocar.do",
  ASISTENCIA_DISPOSITIVO_BANDEJA:
    environment.apiUrl + "controller/asistencia/dispositivo/bandeja.do",
  /** Inicio > pestaña Asistencia: presentes hoy, sin registrar, minutos de retardo y graficas del periodo. */
  ASISTENCIA_DASHBOARD:
    environment.apiUrl + "controller/asistencia/dashboard.do",

  // Path: controller/planes/ — Planes de MI empresa (sólo lectura)
  PLANES_CONSULTAR: environment.apiUrl + "controller/planes/consultar.do",

  // Path: controller/plataforma/ — Solser: clientes y sus planes
  PLATAFORMA_CLIENTES_CONSULTAR:
    environment.apiUrl + "controller/plataforma/clientes/consultar.do",
  PLATAFORMA_CLIENTES_CREAR:
    environment.apiUrl + "controller/plataforma/clientes/crear.do",
  PLATAFORMA_PLANES_CONSULTAR:
    environment.apiUrl + "controller/plataforma/planes/consultar.do",
  PLATAFORMA_PLANES_MODULOS:
    environment.apiUrl + "controller/plataforma/planes/modulos.do",
  PLATAFORMA_PLANES_GUARDAR:
    environment.apiUrl + "controller/plataforma/planes/guardar.do",
  PLATAFORMA_MENU_CONSULTAR:
    environment.apiUrl + "controller/plataforma/menu/consultar.do",
  PLATAFORMA_MENU_GUARDAR:
    environment.apiUrl + "controller/plataforma/menu/guardar.do",

  // Path: controller/equipo/ — Inicio: quién no está hoy y cumpleaños
  EQUIPO_HOY: environment.apiUrl + "controller/equipo/hoy.do",

  // Path: controller/proyectos/ — Inicio: pestaña Proyectos (totales, gráficas, riesgos, desviación)
  PROYECTOS_DASHBOARD: environment.apiUrl + "controller/proyectos/dashboard.do",

  // Proyectos · etapas, versiones y pruebas. Espejo del bloque
  // "PROYECTOS · ETAPAS, VERSIONES Y PRUEBAS" de CosCore UrlConstantes (mismos
  // nombres y URLs). Plan: docs/superpowers/plans/2026-10-13-etapas-y-versiones.md §6.
  PROYECTOS_ETAPAS_VERSIONES: environment.apiUrl + "controller/proyectos/etapas/versiones.do",
  PROYECTOS_VERSION_CREAR:    environment.apiUrl + "controller/proyectos/versiones/crear.do",
  PROYECTOS_PAGINA:           environment.apiUrl + "controller/proyectos/pagina.do",
  PROYECTOS_ETAPAS_RESUMEN:   environment.apiUrl + "controller/proyectos/etapas/resumen.do",
  INCIDENCIA_RESOLUCION_ESTADO:
    environment.apiUrl + "controller/incidencias/resolucion/estado.do",
  PROYECTOS_PRUEBAS_GUARDAR:   environment.apiUrl + "controller/proyectos/pruebas/guardar.do",
  PROYECTOS_PRUEBAS_EVIDENCIA: environment.apiUrl + "controller/proyectos/pruebas/evidencia.do",
  PROYECTOS_VERSION_DETALLE:   environment.apiUrl + "controller/proyectos/versiones/detalle.do",
  PROYECTOS_VERSION_EDITAR:    environment.apiUrl + "controller/proyectos/versiones/editar.do",

  // Path: controller/tickets/ ? Tickets
  CONSULTAAREASOLICITANTE:
    environment.apiUrl + "controller/tickets/consultaAreaSolicitante.do",
  CONSULTAESTATUSSOLICITUD:
    environment.apiUrl + "controller/tickets/consultaEstatus.do",
  CONSULTASOLICITANTE:
    environment.apiUrl + "controller/tickets/consultaSolicitante.do",
  CONSULTATIEMPOATENDIDO:
    environment.apiUrl + "controller/tickets/consultaTiempoAtendido.do",
  CONSULTATIEMPOCANCELADO:
    environment.apiUrl + "controller/tickets/consultaTiempoCancelado.do",
  CONSULTATIEMPOPROCESO:
    environment.apiUrl + "controller/tickets/consultaTiempoProceso.do",
  CONSULTATIEMPOVOBO:
    environment.apiUrl + "controller/tickets/consultaTiempoVoBo.do",
  CONSULTATIPOSOLICITUD:
    environment.apiUrl + "controller/tickets/consultaTipoSolicitud.do",

  // Path: controller/topt/ ? TOPT
  ALTASECRETOS: environment.apiUrl + "controller/topt/altaSecretos",
  CONSULTASECRETOS: environment.apiUrl + "controller/topt/consultaSecretos",
  EXISTTOPT: environment.apiUrl + "controller/topt/existeTOPT",
  GENERAQRTOPT: environment.apiUrl + "controller/topt/generaQRTOPT",
  VALIDATOPT: environment.apiUrl + "controller/topt/validaTOPT/{codigo}",

  // Path: public/denuncias/ ? Canal de denuncias (p?blico)
  DENUNCIA_CATEGORIAS: "public/denuncias/consultarCategorias.do",
  DENUNCIA_CONSULTAR_ESTADO: "public/denuncias/consultarEstadoDenuncia.do",
  DENUNCIA_REGISTRAR: "public/denuncias/registrarDenuncia.do",
  DENUNCIA_UPLOAD_EVIDENCIA: "public/denuncias/uploadEvidencia.do",

  // Path: tarea/autorizaciones/ ? Autorizaciones de tareas
  CONSULTA_TIEMPO_EXTRA_LIDER: "tarea/autorizaciones/consultaLider.do",
  CONSULTA_TIEMPO_EXTRA_USUARIO: "tarea/autorizaciones/consultaUsuario.do",
  RESOLVER_TIEMPO_EXTRA: "tarea/autorizaciones/resolver.do",
  SOLICITAR_TIEMPO_EXTRA: "tarea/autorizaciones/solicitar.do",

  // Path: tarea/capturaManual/ ? Captura manual de tareas
  CONSULTA_SEMANA_MANUAL: "tarea/capturaManual/consultaSemana.do",
  REGISTRAR_BLOQUE_MANUAL: "tarea/capturaManual/registrar.do",

  // Path: (relativa) ? Rutas relativas
  actualizaPassword: "actualizaPass.do",
  CAMBIO_ESTATUS_TAREA_DIARIA: "cambioEstatusTareaDiaria.do",
  DETALLE_PROYECCION: "consultaDetalleProyeccion.do",
  FECHAS_SEMANA: "consultaFechasSemana.do",
  FILTRO_SEMANAS: "consultaFiltroSemanas.do",
  consultaProyectosSinFiltro2: "consultarProyectosSinFiltro2.do",
  CONSULTA_TAREA_DIARIA: "consultaTareaDiaria.do",
  OBTENER_TAREA_HISTORIAL: "consultaTareaHistorial.do",
  CONSULTA_TAREAS_PROYECTO_USUARIO: "consultaTareasProyectoUsuario.do",
  DASHBOARD_TAREAS: "dashboardTareas.do",
  descargaEvidencia: "descargaEvidencia.do",
  ELIMINAR_TAREA: "eliminaTareaRegistrada.do",
  OBTENER_PALETA_COLORES: "obtenerPaletaColores.do",
  PROGRAMAR_TAREA: "programarTarea.do",
  recuperaPass: "restaurarPass.do",
  RESTRICCION_TAREAS: "restriccionTareas.do",
  VALIDAR_PROGRAMACION_TAREA: "validarProgramacionTarea.do",
  consultaVideoEvidencia: "video.do",

  // Calendario de vacaciones
  // Organigrama editable
  ORGANIGRAMA_CONSULTAR: environment.apiUrl + "controller/organigrama/consultar.do",
  ORGANIGRAMA_GUARDAR: environment.apiUrl + "controller/organigrama/guardar.do",
  ORGANIGRAMA_MOVER: environment.apiUrl + "controller/organigrama/mover.do",
  ORGANIGRAMA_ELIMINAR: environment.apiUrl + "controller/organigrama/eliminar.do",
  ORGANIGRAMA_HISTORIAL: environment.apiUrl + "controller/organigrama/historial.do",

  // Catálogo de prompts
  PROMPTS_CONSULTAR: environment.apiUrl + "controller/prompts/consultar.do",
  PROMPTS_GUARDAR: environment.apiUrl + "controller/prompts/guardar.do",
  PROMPTS_ELIMINAR: environment.apiUrl + "controller/prompts/eliminar.do",
  PROMPTS_SECCION_GUARDAR:
    environment.apiUrl + "controller/prompts/seccion/guardar.do",
  PROMPTS_SECCION_ELIMINAR:
    environment.apiUrl + "controller/prompts/seccion/eliminar.do",
  PROMPTS_AREAS_CONSULTAR:
    environment.apiUrl + "controller/prompts/areas/consultar.do",
  PROMPTS_AREAS_GUARDAR:
    environment.apiUrl + "controller/prompts/areas/guardar.do",
  PROMPTS_RETIRADOS: environment.apiUrl + "controller/prompts/retirados.do",
  PROMPTS_RESTAURAR: environment.apiUrl + "controller/prompts/restaurar.do",

  VACACIONES_CONSULTAR: environment.apiUrl + "controller/vacaciones/consultar.do",
  VACACIONES_GUARDAR:   environment.apiUrl + "controller/vacaciones/guardar.do",
  VACACIONES_ELIMINAR:  environment.apiUrl + "controller/vacaciones/eliminar.do",
  VACACIONES_SALDO_GUARDAR: environment.apiUrl + "controller/vacaciones/saldo/guardar.do",
  // Los periodos que se corrigen en «Días de vacaciones»: el anterior, el vigente y los que siguen.
  VACACIONES_SALDO_PERIODOS: environment.apiUrl + "controller/vacaciones/saldo/periodos.do",

  // Solicitud y autorización
  VACACIONES_SOLICITAR: environment.apiUrl + "controller/vacaciones/solicitar.do",
  // Días sueltos: los tramos de un pedido, juntos (15/10/2026).
  VACACIONES_SOLICITAR_PEDIDO: environment.apiUrl + "controller/vacaciones/solicitarPedido.do",
  VACACIONES_RESOLVER:  environment.apiUrl + "controller/vacaciones/resolver.do",
  VACACIONES_FRC:       environment.apiUrl + "controller/vacaciones/frc.do",
  // El FRC-019 firmado a mano («Descargar para firmar»): subir el papel ya
  // firmado y verlo. Lo puede quien puede abrir el FRC-019.
  VACACIONES_FIRMADO_SUBIR: environment.apiUrl + "controller/vacaciones/firmado/subir.do",
  VACACIONES_FIRMADO_VER:   environment.apiUrl + "controller/vacaciones/firmado/ver.do",
  VACACIONES_FIRMADO_HISTORIAL:   environment.apiUrl + "controller/vacaciones/firmado/historial.do",
  VACACIONES_MIAS:      environment.apiUrl + "controller/vacaciones/mias.do",
  VACACIONES_CANCELAR_MIA: environment.apiUrl + "controller/vacaciones/cancelar.do",
  VACACIONES_HISTORIAL:    environment.apiUrl + "controller/vacaciones/historial.do",
  // Seguimiento de solo lectura: "Mi equipo" (el líder) y "Seguimiento
  // RH" (toda la empresa). Vacaciones y permisos del año de una vez.
  VACACIONES_SEGUIMIENTO:  environment.apiUrl + "controller/vacaciones/seguimiento.do",
  // Carga del Excel de RH, en dos pasos como el formato FOS-005: la
  // previa lee el archivo y devuelve el plan SIN escribir nada, y la
  // carga lo aplica. El archivo viaja las dos veces y la huella amarra
  // una con otra, para no dejar nada a medias en el servidor.
  VACACIONES_IMPORTAR_PREVIA: environment.apiUrl + "controller/vacaciones/importar/previa.do",
  VACACIONES_IMPORTAR_CARGAR: environment.apiUrl + "controller/vacaciones/importar/cargar.do",

  // Permisos (FRC-017): faltar un día, salir antes o llegar tarde.
  // Viven en la pestaña de al lado de solicitar vacaciones y comparten su
  // permiso de menú, pero son otra cosa y otra tabla.
  PERMISOS_CONSULTAR: environment.apiUrl + "controller/permisos/consultar.do",
  PERMISOS_SOLICITAR: environment.apiUrl + "controller/permisos/solicitar.do",
  PERMISOS_RESOLVER:  environment.apiUrl + "controller/permisos/resolver.do",
  PERMISOS_CANCELAR:  environment.apiUrl + "controller/permisos/cancelar.do",
  PERMISOS_ARCHIVAR:  environment.apiUrl + "controller/permisos/archivar.do",
  PERMISOS_FRC:       environment.apiUrl + "controller/permisos/frc.do",
  // El FRC-017 firmado a mano: subir el papel ya firmado y verlo.
  PERMISOS_FIRMADO_SUBIR: environment.apiUrl + "controller/permisos/firmado/subir.do",
  PERMISOS_FIRMADO_VER:   environment.apiUrl + "controller/permisos/firmado/ver.do",
  PERMISOS_FIRMADO_HISTORIAL:   environment.apiUrl + "controller/permisos/firmado/historial.do",
  PERMISOS_CALENDARIO: environment.apiUrl + "controller/permisos/calendario.do",
  PERMISOS_POR_RESOLVER: environment.apiUrl + "controller/permisos/porResolver.do",
  // Los permisos del equipo de quien pregunta, para el calendario «Tu
  // equipo» de «Mi equipo» (29/10/2026).
  PERMISOS_EQUIPO: environment.apiUrl + "controller/permisos/equipo.do",

  // Solicitudes de IA (SIA): se pide una IA nueva, la evalúan los cinco,
  // y sólo aprobada entra al inventario ISO 42001.
  SOLICITUDES_IA_MIAS:      environment.apiUrl + "controller/solicitudesIa/mias.do",
  SOLICITUDES_IA_SOLICITAR: environment.apiUrl + "controller/solicitudesIa/solicitar.do",
  SOLICITUDES_IA_BANDEJA:   environment.apiUrl + "controller/solicitudesIa/bandeja.do",
  SOLICITUDES_IA_DETALLE:   environment.apiUrl + "controller/solicitudesIa/detalle.do",
  SOLICITUDES_IA_ASIGNAR:   environment.apiUrl + "controller/solicitudesIa/asignar.do",
  SOLICITUDES_IA_MOVER:     environment.apiUrl + "controller/solicitudesIa/mover.do",
  SOLICITUDES_IA_CANCELAR:  environment.apiUrl + "controller/solicitudesIa/cancelar.do",
  SOLICITUDES_IA_COMENTAR:  environment.apiUrl + "controller/solicitudesIa/comentar.do",
  SOLICITUDES_IA_DAR:       environment.apiUrl + "controller/solicitudesIa/dar.do",
  SOLICITUDES_IA_GUARDAR_DAR: environment.apiUrl + "controller/solicitudesIa/guardarDar.do",

  // Mantenimiento: instalaciones y edificio. Se pide, alguien de
  // mantenimiento la toma y la resuelve, y quien la pidió da el visto bueno.
  MANTENIMIENTO_MIAS:        environment.apiUrl + "controller/mantenimiento/mias.do",
  MANTENIMIENTO_SOLICITAR:   environment.apiUrl + "controller/mantenimiento/solicitar.do",
  MANTENIMIENTO_BANDEJA:     environment.apiUrl + "controller/mantenimiento/bandeja.do",
  MANTENIMIENTO_DETALLE:     environment.apiUrl + "controller/mantenimiento/detalle.do",
  MANTENIMIENTO_TOMAR:       environment.apiUrl + "controller/mantenimiento/tomar.do",
  MANTENIMIENTO_REASIGNAR:   environment.apiUrl + "controller/mantenimiento/reasignar.do",
  MANTENIMIENTO_MOVER:       environment.apiUrl + "controller/mantenimiento/mover.do",
  MANTENIMIENTO_CONFIRMAR:   environment.apiUrl + "controller/mantenimiento/confirmar.do",
  MANTENIMIENTO_REABRIR:     environment.apiUrl + "controller/mantenimiento/reabrir.do",
  MANTENIMIENTO_CANCELAR:    environment.apiUrl + "controller/mantenimiento/cancelar.do",
  MANTENIMIENTO_COMENTAR:    environment.apiUrl + "controller/mantenimiento/comentar.do",
  MANTENIMIENTO_FOTO_SUBIR:  environment.apiUrl + "controller/mantenimiento/fotoSubir.do",
  MANTENIMIENTO_FOTO_VER:    environment.apiUrl + "controller/mantenimiento/fotoVer.do",
  MANTENIMIENTO_FOTO_QUITAR: environment.apiUrl + "controller/mantenimiento/fotoQuitar.do",

    // Evaluaciones IA Solser: los proveedores de IA que usa SOLSER, con su
  // cuestionario, su expediente y su dictamen firmado. Los archivos van por
  // el almacén de evidencias (ISO42001_MATRIZ_EVIDENCIA_*).
  EVALUACIONES_IA_LISTA:       environment.apiUrl + "controller/evaluacionesIa/lista.do",
  EVALUACIONES_IA_DETALLE:     environment.apiUrl + "controller/evaluacionesIa/detalle.do",
  EVALUACIONES_IA_HISTORIAL:   environment.apiUrl + "controller/evaluacionesIa/historial.do",
  EVALUACIONES_IA_CREAR:       environment.apiUrl + "controller/evaluacionesIa/crear.do",
  EVALUACIONES_IA_DATOS:       environment.apiUrl + "controller/evaluacionesIa/datos.do",
  EVALUACIONES_IA_RESPONDER:   environment.apiUrl + "controller/evaluacionesIa/responder.do",
  EVALUACIONES_IA_LIMPIAR:     environment.apiUrl + "controller/evaluacionesIa/limpiar.do",
  EVALUACIONES_IA_OBSERVACION: environment.apiUrl + "controller/evaluacionesIa/observacion.do",
  EVALUACIONES_IA_REFERENCIA:  environment.apiUrl + "controller/evaluacionesIa/referencia.do",
  EVALUACIONES_IA_FIRMAR:      environment.apiUrl + "controller/evaluacionesIa/firmar.do",
  EVALUACIONES_IA_REABRIR:     environment.apiUrl + "controller/evaluacionesIa/reabrir.do",
  EVALUACIONES_IA_ELIMINAR:    environment.apiUrl + "controller/evaluacionesIa/eliminar.do",

  // Homologación de Modelos IA: qué versión de un modelo sirve para desarrollo.
  HOMOLOGACION_MODELOS_MODELOS:       environment.apiUrl + "controller/homologacionModelos/modelos.do",
  HOMOLOGACION_MODELOS_CATALOGOS:     environment.apiUrl + "controller/homologacionModelos/catalogos.do",
  HOMOLOGACION_MODELOS_MODELO_GUARDAR: environment.apiUrl + "controller/homologacionModelos/modeloGuardar.do",
  HOMOLOGACION_MODELOS_MODELO_BAJA:   environment.apiUrl + "controller/homologacionModelos/modeloBaja.do",
  HOMOLOGACION_MODELOS_EVALUACIONES:  environment.apiUrl + "controller/homologacionModelos/evaluaciones.do",
  HOMOLOGACION_MODELOS_PREVIA:        environment.apiUrl + "controller/homologacionModelos/previa.do",
  HOMOLOGACION_MODELOS_CARGAR:        environment.apiUrl + "controller/homologacionModelos/cargar.do",
  HOMOLOGACION_MODELOS_DETALLE:       environment.apiUrl + "controller/homologacionModelos/detalle.do",
  HOMOLOGACION_MODELOS_DESCARGA:      environment.apiUrl + "controller/homologacionModelos/descarga.do",
  HOMOLOGACION_MODELOS_ELIMINAR:      environment.apiUrl + "controller/homologacionModelos/eliminar.do",
  HOMOLOGACION_MODELOS_HISTORIAL:     environment.apiUrl + "controller/homologacionModelos/historial.do",
  HOMOLOGACION_MODELOS_FIRMAR:        environment.apiUrl + "controller/homologacionModelos/firmar.do",
  HOMOLOGACION_MODELOS_REABRIR:       environment.apiUrl + "controller/homologacionModelos/reabrir.do",
  HOMOLOGACION_MODELOS_FICHA_PREVIA:   environment.apiUrl + "controller/homologacionModelos/fichaPrevia.do",
  HOMOLOGACION_MODELOS_FICHA_CARGAR:   environment.apiUrl + "controller/homologacionModelos/fichaCargar.do",
  HOMOLOGACION_MODELOS_FICHAS:         environment.apiUrl + "controller/homologacionModelos/fichas.do",
  HOMOLOGACION_MODELOS_FICHA:          environment.apiUrl + "controller/homologacionModelos/ficha.do",
  HOMOLOGACION_MODELOS_FICHA_DESCARGA: environment.apiUrl + "controller/homologacionModelos/fichaDescarga.do",
  HOMOLOGACION_MODELOS_FICHA_ELIMINAR: environment.apiUrl + "controller/homologacionModelos/fichaEliminar.do",
  HOMOLOGACION_MODELOS_CONSULTA_VARAS:       environment.apiUrl + "controller/homologacionModelos/consulta/varas.do",
  HOMOLOGACION_MODELOS_CONSULTA_MODELOS:     environment.apiUrl + "controller/homologacionModelos/consulta/modelos.do",
  HOMOLOGACION_MODELOS_CONSULTA_COMPARATIVA: environment.apiUrl + "controller/homologacionModelos/consulta/comparativa.do",
  HOMOLOGACION_MODELOS_CONSULTA_RESULTADO:   environment.apiUrl + "controller/homologacionModelos/consulta/resultado.do",
  HOMOLOGACION_MODELOS_CONSULTA_FICHA:       environment.apiUrl + "controller/homologacionModelos/consulta/ficha.do",

  // PIN personal del autorizador (de plataforma): Ajustes y Personas › Empleados.
  PIN_AUTORIZADOR_ESTADO:      environment.apiUrl + "controller/pinAutorizador/estado.do",
  PIN_AUTORIZADOR_ESTABLECER:  environment.apiUrl + "controller/pinAutorizador/establecer.do",
  PIN_AUTORIZADOR_CAMBIAR:     environment.apiUrl + "controller/pinAutorizador/cambiar.do",
  PIN_AUTORIZADOR_RESTABLECER: environment.apiUrl + "controller/pinAutorizador/restablecer.do",

  // BSC (FOR-011): Balanced Scorecard por área. Espejo del bloque
  // "BSC (FOR-011)" de CosCore UrlConstantes (mismos nombres y URLs).
  // Todos POST BscReq -> BscRes salvo los multipart de importación
  // (IMPORTAR_*) y los GET de exportación (EXPORTAR*). Plan: docs/BSC.md §5.
  BSC_CATALOGOS:               environment.apiUrl + "controller/bsc/catalogos.do",
  BSC_INDICADORES_CONSULTAR:               environment.apiUrl + "controller/bsc/indicadores/consultar.do",
  BSC_INDICADORES_NORMA:               environment.apiUrl + "controller/bsc/indicadores/norma.do",
  BSC_INDICADORES_LISTA:               environment.apiUrl + "controller/bsc/indicadores/lista.do",
  BSC_INDICADORES_SUGERIR:               environment.apiUrl + "controller/bsc/indicadores/sugerir.do",
  BSC_INDICADORES_EXPORTAR:               environment.apiUrl + "controller/bsc/indicadores/exportar.do",
  BSC_DASHBOARD:               environment.apiUrl + "controller/bsc/dashboard.do",
  BSC_AREA_DETALLE:            environment.apiUrl + "controller/bsc/area/detalle.do",
  BSC_KPI_FICHA:               environment.apiUrl + "controller/bsc/kpi/ficha.do",
  BSC_MI_BSC:                  environment.apiUrl + "controller/bsc/captura/miBsc.do",
  BSC_MES_CAPTURAR:            environment.apiUrl + "controller/bsc/captura/mes.do",
  BSC_REAL_CAPTURAR:           environment.apiUrl + "controller/bsc/captura/real.do",
  BSC_TRIMESTRE_PREVIA_CIERRE: environment.apiUrl + "controller/bsc/captura/previaCierre.do",
  BSC_TRIMESTRE_CERRAR:        environment.apiUrl + "controller/bsc/captura/cerrar.do",
  BSC_REVISION_BANDEJA:        environment.apiUrl + "controller/bsc/revision/bandeja.do",
  BSC_REVISION_DETALLE:        environment.apiUrl + "controller/bsc/revision/detalle.do",
  BSC_REVISION_RESOLVER:       environment.apiUrl + "controller/bsc/revision/resolver.do",
  BSC_REVISION_REABRIR:        environment.apiUrl + "controller/bsc/revision/reabrir.do",
  BSC_REVISION_RECORDAR:       environment.apiUrl + "controller/bsc/revision/recordar.do",
  BSC_PLANEACION_CONSULTAR:    environment.apiUrl + "controller/bsc/planeacion/consultar.do",
  BSC_PLANEACION_CREAR:        environment.apiUrl + "controller/bsc/planeacion/crear.do",
  BSC_PLANEACION_GUARDAR:      environment.apiUrl + "controller/bsc/planeacion/guardar.do",
  BSC_PLANEACION_ENVIAR:       environment.apiUrl + "controller/bsc/planeacion/enviar.do",
  BSC_PLANEACION_RESOLVER:     environment.apiUrl + "controller/bsc/planeacion/resolver.do",
  BSC_COMPARATIVO:             environment.apiUrl + "controller/bsc/comparativo.do",
  BSC_PARAMETROS_CONSULTAR:    environment.apiUrl + "controller/bsc/parametros/consultar.do",
  BSC_PARAMETROS_GUARDAR:      environment.apiUrl + "controller/bsc/parametros/guardar.do",
  BSC_PARAMETROS_AREA_GUARDAR: environment.apiUrl + "controller/bsc/parametros/area.do",
  BSC_PARAMETROS_KPIS:         environment.apiUrl + "controller/bsc/parametros/kpis.do",
  BSC_PARAMETROS_FUSIONAR_KPI: environment.apiUrl + "controller/bsc/parametros/fusionarKpi.do",
  BSC_PARAMETROS_RECALCULAR:   environment.apiUrl + "controller/bsc/parametros/recalcularSnapshots.do",
  BSC_CICLO_CERRAR:            environment.apiUrl + "controller/bsc/parametros/cerrarCiclo.do",
  BSC_IMPORTAR_PREVIA:         environment.apiUrl + "controller/bsc/importar/previa.do",
  BSC_IMPORTAR_CARGAR:         environment.apiUrl + "controller/bsc/importar/cargar.do",
  BSC_EXPORTAR:                environment.apiUrl + "controller/bsc/exportar.do",
  BSC_EXPORTAR_CONSOLIDADO:    environment.apiUrl + "controller/bsc/exportarConsolidado.do",

  // Calidad de código (SonarQube). Espejo del bloque «Calidad de código
  // (SonarQube)» de CosCore UrlConstantes (mismos nombres y URLs). Cada uno es
  // POST CalidadCodigoReq -> CalidadCodigoRes salvo REPORTE_EXCEL, GET ?folio=
  // que contesta el .xlsx. Plan: docs/CALIDAD_CODIGO.md §4.
  CALIDAD_CODIGO_TABLERO:               environment.apiUrl + "controller/calidadCodigo/tablero.do",
  CALIDAD_CODIGO_PROYECTO:              environment.apiUrl + "controller/calidadCodigo/proyecto.do",
  CALIDAD_CODIGO_HISTORIAL:             environment.apiUrl + "controller/calidadCodigo/historial.do",
  CALIDAD_CODIGO_ACTUALIZAR:            environment.apiUrl + "controller/calidadCodigo/actualizar.do",
  CALIDAD_CODIGO_REPORTE_EMITIR:        environment.apiUrl + "controller/calidadCodigo/reporteEmitir.do",
  CALIDAD_CODIGO_REPORTES:              environment.apiUrl + "controller/calidadCodigo/reportes.do",
  CALIDAD_CODIGO_REPORTE_DATOS:         environment.apiUrl + "controller/calidadCodigo/reporteDatos.do",
  CALIDAD_CODIGO_REPORTE_EXCEL:         environment.apiUrl + "controller/calidadCodigo/reporteExcel.do",
  CALIDAD_CODIGO_CONFIGURACION:         environment.apiUrl + "controller/calidadCodigo/configuracion.do",
  CALIDAD_CODIGO_CONFIGURACION_GUARDAR: environment.apiUrl + "controller/calidadCodigo/configuracionGuardar.do",

  // Mantenimiento de módulos (16/10/2026): poner pantallas y funciones del
  // COS en mantenimiento, con un aviso para quien entra.
  MANTENIMIENTO_MODULOS_ACTIVOS:  environment.apiUrl + "controller/mantenimientoModulos/activos.do",
  MANTENIMIENTO_MODULOS_CATALOGO: environment.apiUrl + "controller/mantenimientoModulos/catalogo.do",
  MANTENIMIENTO_MODULOS_GUARDAR:  environment.apiUrl + "controller/mantenimientoModulos/guardar.do",
  MANTENIMIENTO_MODULOS_TERMINAR: environment.apiUrl + "controller/mantenimientoModulos/terminar.do",

  // Referencias hist?ricas sin consumidores activos:
  // SSIncQA: environment.socketURL + "controller/consultaDetallesQA.do",
  // GUARDAR_OPORTUNIDAD_SEGUIMIENTO_Desarrollo: environment.apiUrl + "controller/guardarOportunidadSeguimientoDesarrollo",
};
